export const CLICK = 'click';
export const COMMENT = 'comment';
export const BOOKMARK = 'bookmark';
export const UPVOTE = 'upvote';
export const FLAG = 'flag';
export const DWELL = 'dwell';
